import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Cells should be center-aligned, but all values in a column should
// have the same right-alignment.
const Value = styled.span`
  min-width: ${({ precision, unit }) => (precision + unit.length)}em;
  text-align: right;
  display: inline-block;
`;

function getDisplayValue(value, precision) {
  if (typeof value === 'string') {
    return value;
  }

  const preciseValue = Number.parseFloat(value).toFixed(precision);
  return isNaN(preciseValue) ? '—' : preciseValue;
}

function CellValue({ value, children, precision, unit }) {
  const displayValue = getDisplayValue(value || children, precision);

  return (
    <Value precision={precision} unit={unit}>
      {displayValue}
      {unit && !isNaN(displayValue) && ` ${unit}`}
    </Value>
  );
}

CellValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.any,
  precision: PropTypes.number,
  unit: PropTypes.string,
};

CellValue.defaultProps = {
  precision: 1,
  unit: '',
};

export default CellValue;
